import { render, staticRenderFns } from "./EnrollUser.vue?vue&type=template&id=5b334c2a&scoped=true&"
import script from "./EnrollUser.vue?vue&type=script&lang=js&"
export * from "./EnrollUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b334c2a",
  null
  
)

export default component.exports